import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import { MessageBox } from "element-ui";
import { Editor } from "tinymce";
import { nextTick } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'preview-online-answer-sheet-dialog',
  props: {
    isVisible: { type: Boolean },
    textEditorInstance: null
  },
  emits: {
  "on-close": () => true,
  "on-submit-intent": () => true,
},
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  textEditorInstance?: Editor;
}





const onClose = () => {
  emit("on-close");
};

const onSubmitOnlineAnswerSheetIntent = () => {
  return MessageBox.alert(
    "You are about to submit your answer sheet. Are you sure you want to proceed?",
    {
      title: "Submit Answer Sheet",
      confirmButtonText: "Yes, Submit",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      distinguishCancelAndClose: true,
      closeOnClickModal: true,
      closeOnPressEscape: true,
      callback: (action) => {
        if (action == "confirm") {
          emit("on-submit-intent");
        }
      },
    }
  );
};

const onDialogOpen = async () => {
  await nextTick();

  const iframe = document.querySelector(
    "iframe#contentFrame"
  ) as HTMLIFrameElement;

  if (iframe && iframe.contentDocument) {
    const doc = iframe.contentDocument;
    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            body {
              margin: 0;
              font-family: Arial, sans-serif;
              overflow-y: scroll; /* Always show scrollbar */
            }

            /* Optional: Customize scrollbar appearance for Webkit-based browsers */
            body::-webkit-scrollbar {
              width: 8px;
              height: 8px;
            }
            body::-webkit-scrollbar-thumb {
              background-color: #888;
              border-radius: 4px;
            }
            body::-webkit-scrollbar-thumb:hover {
              background-color: #555;
            }
            body::-webkit-scrollbar-track {
              background: #f1f1f1;
            }
          </style>
        </head>
        <body>
         ${props.textEditorInstance?.getContent({ format: "html" }) || ""}
        </body>
      </html>
    `);
    doc.close();
  }
};

return { __sfc: true,props, emit, onClose, onSubmitOnlineAnswerSheetIntent, onDialogOpen, BaseDialog }
}

})